import ImageOptimizer from '@/components/image-optimizer';
import { AcademyReviewEntity } from '@/services/types/academy.type';

interface Props {
  review: AcademyReviewEntity;
}

const AcademyReviewCard = ({ review }: Props) => {
  return (
    <div className="bg-bg-graylight desktop:py-4 flex h-[112px] items-center justify-center rounded-lg px-5 py-5">
      {review.photoPath && (
        <ImageOptimizer
          src={review.photoPath}
          alt="리뷰 이미지"
          width={80}
          height={80}
          className="mr-4 h-20 w-20 rounded-lg object-cover"
          loading="eager"
        />
      )}
      <div className="flex flex-1 flex-col justify-center">
        {/* 닉네임 */}
        <div className="text-level-1 typo-18 w-full pb-2 font-bold">
          {review.username}
        </div>
        {/* 리뷰 내용 */}
        <p className="text-level-4 typo-14 line-clamp-2 w-full leading-[22px] font-semibold">
          {review.content}
        </p>
      </div>
    </div>
  );
};

export default AcademyReviewCard;
